import React, { memo } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { generateAvatarColorForName } from 'v2/util/AvatarColorGenerator';

type DefaultProjectIconProps = {
  projectName: string;
};

const DefaultProjectIcon: React.FC<DefaultProjectIconProps> = ({
  projectName,
}) => {
  const { height = 0, ref } = useResizeDetector();
  var firstCharOfProjectName = '';
  if (projectName.length > 0) {
    firstCharOfProjectName = projectName[0].toLocaleUpperCase();
  }

  return (
    <div
      ref={ref}
      style={{
        width: '100%',
        height: '100%',
        borderRadius: height * 0.5,
        backgroundColor: generateAvatarColorForName(projectName),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: height * 0.7, color: 'white', margin: 0 }}>
        {firstCharOfProjectName}
      </p>
    </div>
  );
};

export default memo(DefaultProjectIcon);
